import React from 'react';
import { useEmployeeRequestFormsQuery } from '../../../__generated__/graphql';
import { RequestForm } from '../RequestForm';

type Props = {
  show: boolean;
  recordType: string;
  showAllRequests: boolean;
  onHide: () => void;
};

export const EmployeeRequestForm: React.FC<Props> = (props) => {
  const { data, loading } = useEmployeeRequestFormsQuery({
    skip: !props.show,
  });

  return (
    <RequestForm
      {...props}
      requestForms={data?.requestForms ?? []}
      employees={[]}
      loading={loading}
    />
  );
};
